import Vue from 'vue'
import Component from 'vue-class-component'
import {Action} from 'vuex-class'
import {CheckAuthorizationResult} from '@/modules/authorization/model/CheckAuthorizationResult'

/**
 * Utilidades de autorización
 *
 * Mixin de Vue con utilidades para comprobar autorización del usuario
 * desde los componentes
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class Authorizable extends Vue {
    /**
     * Comprobar autorización
     *
     * Solicita a la aplicación que compruebe si el usuario actual posee los
     * permisos argumentados
     */
    @Action('authorization/checkAuthorization')
    public authorize: (string: string[]) => Promise<CheckAuthorizationResult>

    /**
     * Comprueba si el usuario posee el permiso argumentado
     *
     * Solo busca en los permisos ya cargados en la aplicación, para solicitar
     * la autorización al servidor ejecutar Authorizable.authorize
     *
     * @param permission
     */
    public hasPermission (permission: string): boolean {
        const granted: string[] = this.$store.state.authorization.grantedPermissions

        return !!granted.find(p => p === permission)
    }
}
